<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BarChart from 'shared/components/charts/BarChart.vue';
import { CHART_FONT_FAMILY } from '../../constants';

const props = defineProps({
  row: {
    type: Object,
    default: null,
  },
  emptyMessage: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();

const hasData = computed(() => !!props.row && props.row.total > 0);

const collection = computed(() => ({
  labels: [
    t('CUSTOM_SLA_REPORTS.CHARTS.FIRST_RESPONSE'),
    t('CUSTOM_SLA_REPORTS.CHARTS.NEXT_RESPONSE'),
    t('CUSTOM_SLA_REPORTS.CHARTS.RESOLUTION'),
  ],
  datasets: [
    {
      type: 'bar',
      backgroundColor: [
        'rgb(31, 147, 255)',
        'rgb(245, 158, 11)',
        'rgb(225, 29, 72)',
      ],
      label: t('CUSTOM_SLA_REPORTS.CHARTS.BREACH_TYPE_BREAKDOWN'),
      data: props.row
        ? [
            props.row.first_response || 0,
            props.row.next_response || 0,
            props.row.resolution || 0,
          ]
        : [0, 0, 0],
    },
  ],
}));

const chartOptions = {
  plugins: {
    legend: { display: false },
  },
  scales: {
    x: {
      ticks: { fontFamily: CHART_FONT_FAMILY },
      grid: { drawOnChartArea: false },
    },
    y: {
      type: 'linear',
      position: 'left',
      ticks: { fontFamily: CHART_FONT_FAMILY, beginAtZero: true, stepSize: 1 },
      grid: { drawOnChartArea: false },
    },
  },
};
</script>

<template>
  <div
    class="flex flex-col gap-2 p-4 rounded-xl outline outline-1 outline-n-container bg-n-solid-2"
  >
    <span class="text-heading-3 text-n-slate-12">
      {{ title || $t('CUSTOM_SLA_REPORTS.CHARTS.BREACH_TYPE_BREAKDOWN') }}
    </span>
    <div class="h-56">
      <BarChart
        v-if="hasData"
        :collection="collection"
        :chart-options="chartOptions"
      />
      <div
        v-else
        class="flex items-center justify-center h-full text-sm text-n-slate-10"
      >
        {{ emptyMessage }}
      </div>
    </div>
  </div>
</template>
